<div class="topbar">
  <div class="container-xxl">
    <nav class="topbar-custom topbar__nav" [class.nav-sticky]="scrollY > 50" id="topbar-custom">
      <ul class="topbar-item topbar__list">
        <li class="welcome-text">
          <div class="welcome-text__row">
            @if (isMobileViewport && !isSidebarOpen) {
            <button
              type="button"
              class="welcome-text__menu-button d-flex justify-content-center align-items-center thumb-xl bg-light rounded-circle mx-auto"
              (click)="toggleMobileMenu()"
              aria-label="Abrir menu de navegação"
            >
              <i class="iconoir-list h1 align-self-center mb-0 text-secondary" aria-hidden="true"></i>
            </button>
            }
            <h3 class="welcome-text__title">{{ saudacao }}, {{ nomeUsuario }}</h3>
          </div>
          @if (listaSelecionada) {
          <span class="welcome-text__subtitle">Lista selecionada: <strong>{{ listaSelecionadaLabel }}</strong></span>
          }
          @if (aviso) {
          <span class="badge bg-warning text-dark ms-2" [attr.title]="avisoDetalhe">{{ aviso }}</span>
          }
        </li>
      </ul>

      <ul class="topbar-item topbar__list">
        <li class="hide-phone top-search">
          <form role="search" class="top-search__form" (submit)="$event.preventDefault()">
            <input
              #buscaTypeahead="ngbTypeahead"
              type="search"
              name="search"
              class="form-control top-search__input"
              placeholder="Buscar espécies ..."
              aria-label="Buscar espécies"
              [attr.aria-describedby]="mensagemBusca ? 'top-search-status' : null"
              autocomplete="off"
              placement="bottom-start"
              [(ngModel)]="termoBusca"
              [ngbTypeahead]="buscar"
              [resultTemplate]="resultadoBuscaTpl"
              [inputFormatter]="formatarResultado"
              (selectItem)="selecionarResultado($event.item); $event.preventDefault()"
              (keydown.escape)="buscaTypeahead.dismissPopup()"
              (focus)="atualizarBusca()"
              (blur)="encerrarBusca()"
              popupClass="top-search__popup"
            />
          </form>

          @if (mensagemBusca; as mensagem) {
          <div id="top-search-status" class="top-search__status" role="status" aria-live="polite">
            <span>{{ mensagem }}</span>
          </div>
          }

          <ng-template #resultadoBuscaTpl let-r="result" let-t="term">
            <div class="top-search-result">
              <span class="top-search-result__text">
                <ngb-highlight class="top-search-result__title" [result]="r.titulo" [term]="t" />
                <small class="top-search-result__subtitle">{{ r.subtitulo }}</small>
              </span>
              <span class="top-search-result__tipo" [attr.data-tipo]="r.tipo">{{ r.tipo }}</span>
            </div>
          </ng-template>
        </li>

        <li class="topbar-item">
          <button class="nav-link nav-icon" (click)="changeTheme()" id="light-dark-mode">
            <i class="icofont-sun dark-mode"></i>
            <i class="icofont-moon light-mode"></i>
          </button>
        </li>

        <!-- <li class="dropdown topbar-item" ngbDropdown>
          <button class="nav-link dropdown-toggle arrow-none nav-icon" ngbDropdownToggle aria-haspopup="false" aria-expanded="false">
            <i class="icofont-bell-alt"></i>
            <span class="alert-badge"></span>
          </button>
          <div class="dropdown-menu stop dropdown-menu-end dropdown-lg py-0" ngbDropdownMenu>
            <h5 class="dropdown-item-text notification__header">
              Notifications
              <span class="badge badge-pill notification__add-btn">
                <i class="iconoir-plus-circle fs-4"></i>
              </span>
            </h5>
            <ul ngbNav #nav="ngbNav" class="nav nav-tabs nav-tabs-custom nav-success nav-justified notification__tabs" role="tablist">
              @for (tab of tabItems; track $index) {
              <li class="nav-item" role="presentation" ngbNavItem>
                <button class="nav-link mx-0" ngbNavLink role="tab">
                  {{ tab.tabName }}
                  @if ($index == 0) {
                  <span class="badge badge-pill notification__badge">
                    24
                  </span>
                  }
                </button>
                <ng-template ngbNavContent>
                  <div class="tab-pane fade show active" role="tabpanel">
                    @for (item of tab.tabContent; track $index) {
                    <div class="dropdown-item notification-item">
                      <small class="notification-item__time">{{
                        item.time
                        }}</small>
                      <div class="notification-item__body">
                        <div class="thumb-md rounded-circle notification-item__icon">
                          <i [class]="item.iconClass + ' fs-4'"></i>
                        </div>
                        <div class="notification-item__content">
                          <h6 class="notification-item__title">
                            {{ item.title }}
                          </h6>
                          <small class="notification-item__desc">{{
                            item.description
                            }}</small>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </ng-template>
              </li>
              }
            </ul>
            <ngx-simplebar class="ms-0" style="max-height: 230px">
              <div class="tab-content" id="myTabContent" [ngbNavOutlet]="nav"></div>
            </ngx-simplebar>
          </div>
        </li> -->

        <li class="dropdown topbar-item" ngbDropdown placement="bottom-end">
          <button class="nav-link dropdown-toggle arrow-none nav-icon" ngbDropdownToggle aria-haspopup="false" aria-expanded="false">
            <img [src]="avatarUsuario" alt="Foto de Perfil" class="thumb-lg rounded-circle" />
          </button>
          <div class="dropdown-menu dropdown-menu-end py-0" ngbDropdownMenu>
            <div class="dropdown-item profile-header">
              <div class="profile-header__avatar-wrapper">
                <img [src]="avatarUsuario" alt="Foto de Perfil" class="thumb-md rounded-circle" />
              </div>
              <div class="profile-header__info">
                <h6 class="profile-header__name">{{ this.currentUser.user()?.nome ?? nomeUsuario }}</h6>
                <small class="profile-header__email">{{ this.currentUser.user()?.email ?? '' }}</small>
              </div>
            </div>

            <div class="dropdown-divider mt-0"></div>
            <small class="dropdown-menu__section-title">Conta</small>
            <a class="dropdown-item" routerLink="/perfil">
              <i class="las la-user dropdown-menu__icon"></i>
              Perfil Usuário
            </a>

            <!-- <small class="dropdown-menu__section-title">Configuração</small>
            <a class="dropdown-item" routerLink="/perfil">
              <i class="las la-cog dropdown-menu__icon"></i>
              Conta
            </a> -->

            <div class="dropdown-divider mb-0"></div>
            <button type="button" class="dropdown-item dropdown-menu__item--danger" (click)="auth.logout()">
              <i class="las la-power-off dropdown-menu__icon"></i>
              Sair
            </button>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</div>
